import styled from 'styled-components';

//TODO DSA
const StyleContainer = styled.div`
  height: calc(100% - 90px);
  position: relative;
`;

//TODO DSA
const StyleNavContainer = styled.div`
  height: calc(100% - 70px);
`;

const StylePageContainer = styled.div`
  width: ${(props) =>
    props.navOpen ? 'calc(100vw - 355px)' : 'calc(100vw - 55px)'};
  left: ${(props) => (props.navOpen ? '295px' : '0px')};
  transition: left 0.2s ease-out 0s;
`;

export { StyleContainer, StyleNavContainer, StylePageContainer };
